

const materialFilterVariantMap = {
  'gid://shopify/FilterSettingGroup/130285704': '10K Gold',
  'gid://shopify/FilterSettingGroup/130318472': '14K Gold',
};

const materialFilterProductCache = new Map();

const getMaterialFilterProduct = (handle) => {
  if (!materialFilterProductCache.has(handle)) {
    const productUrl = `${window.Shopify.routes.root}products/${handle}.js`;
    materialFilterProductCache.set(
      handle,
      fetch(productUrl).then((response) => {
        if (!response.ok) throw new Error(`Unable to load ${handle}`);
        return response.json();
      })
    );
  }

  return materialFilterProductCache.get(handle);
};

const getSelectedMaterialFilter = () => {
  const params = new URLSearchParams(window.location.search);
  const values = params.getAll('filter.v.option.jewelry material');
  const groupId = values.find((value) => materialFilterVariantMap[value]);
  return values.find((value) => ['10K Gold', '14K Gold', '18K Gold Vermeil', '925 Sterling Silver'].includes(value)) || materialFilterVariantMap[groupId] || null;
};

const getCardCurrency = (card) => {
  const priceText = card.querySelector('.price-item')?.textContent || '';
  return priceText.match(/\b[A-Z]{3}\b/)?.[0] || 'USD';
};

const formatCardMoney = (cents, currency) => {
  const locale = document.documentElement.lang || 'en';
  const amount = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: currency === 'USD' ? 0 : undefined,
  }).format(cents / 100);

  return currency === 'USD' ? amount : `${amount} ${currency}`;
};

const updateCardPriceForVariant = (card, variant) => {
  card.dataset.suriPrice = String(variant.price);
  const price = card.querySelector('.price');
  if (!price) return;

  const currency = getCardCurrency(card);
  const currentPrice = formatCardMoney(variant.price, currency);
  const compareAtPrice = variant.compare_at_price;
  const isOnSale = compareAtPrice && compareAtPrice > variant.price;

  price.classList.toggle('price--on-sale', Boolean(isOnSale));

  price.querySelectorAll('.price__regular .price-item--regular').forEach((element) => {
    element.textContent = isOnSale
      ? formatCardMoney(compareAtPrice, currency)
      : currentPrice;
  });

  price.querySelectorAll('.price__sale .price-item--sale').forEach((element) => {
    element.textContent = currentPrice;
  });

  price.querySelectorAll('.price__sale .price__compare .price-item--regular').forEach((element) => {
    element.textContent = isOnSale
      ? formatCardMoney(compareAtPrice, currency)
      : '';
  });
};

const updateCardLinksForVariant = (card, variantId) => {
  card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('variant', variantId);
    link.href = `${url.pathname}${url.search}${url.hash}`;
  });

  const variantInput = card.querySelector('.card__add-to-cart input[name="id"]');
  if (variantInput) variantInput.value = variantId;
};

const updateMaterialFilterPrices = () => {
  const material = getSelectedMaterialFilter();
  if (!material) return;

  document
    .querySelectorAll('.js-color-swatches-wrapper[data-product]')
    .forEach((card) => {
      // Liquid already resolves this exact material for initial and filtered cards.
      if (card.dataset.suriDefaultVariantId) return;
      const handle = card.dataset.product;
      const selectedColor = card.querySelector('.js-color-swatches input:checked')?.value;

      getMaterialFilterProduct(handle)
        .then((product) => {
          const materialVariants = product.variants.filter(
            (variant) => variant.available && variant.options.includes(material)
          );

          const variant =
            materialVariants.find(
              (item) => selectedColor && item.options.includes(selectedColor)
            ) || materialVariants[0];

          if (!variant) return;

          updateCardPriceForVariant(card, variant);
          updateCardLinksForVariant(card, variant.id);
        })
        .catch(() => {
          // Keep the server-rendered card price if product JSON is unavailable.
        });
    });
};

const initializeMaterialFilterPrices = () => {
  updateMaterialFilterPrices();

  const productGrid = document.querySelector('#ProductGridContainer');
  if (!productGrid) return;

  const observer = new MutationObserver(() => {
    updateMaterialFilterPrices();
  });

  observer.observe(productGrid, { childList: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMaterialFilterPrices, {
    once: true,
  });
} else {
  initializeMaterialFilterPrices();
}
const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      if (wrapper.dataset.suriFinishCard || input.dataset.suriSwatchBound) return;
      input.dataset.suriSwatchBound = 'true';
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            // Keep this bracelet's product and model photos paired for each finish.
            if (handleProduct === 'evangelina-cross-birthstone-tennis-bracelet') {
              const selectedColor = wrapper.querySelector('.js-color-swatches input:checked')?.value;
              if (selectedColor !== currentColor) return;
              const finish = currentColor.toLowerCase().replace(/\s+/g, '-');
              const productMedia = product.media.find(media => media.src?.includes('/evangelina-' + finish + '-product.png'));
              const modelMedia = product.media.find(media => media.src?.includes('/evangelina-' + finish + '-model-1.png'));
              if (productMedia && modelMedia) {
                const nextPrimary = createImageElement(productMedia, primaryImage.className, primaryImage.sizes, product.title);
                const nextSecondary = createImageElement(modelMedia, secondaryImage?.className || primaryImage.className.replace('media--first', 'media--second'), primaryImage.sizes, product.title);
                primaryImage.replaceWith(nextPrimary);
                if (secondaryImage) secondaryImage.replaceWith(nextSecondary);
                else nextPrimary.after(nextSecondary);
              }
              return;
            }
            if (handleProduct === 'evangelina-cross-birthstone-tennis-ring') {
              const selectedColor = wrapper.querySelector('.js-color-swatches input:checked')?.value;
              if (selectedColor !== currentColor) return;
              const finish = currentColor.toLowerCase().replace(/\s+/g, '-');
              const productMedia = product.media.find(media => media.src?.includes('/evangelina-ring-' + finish + '-product.png'));
              const modelMedia = product.media.find(media => media.src?.includes('/evangelina-ring-' + finish + '-model-1.png'));
              if (productMedia && modelMedia) {
                const nextPrimary = createImageElement(productMedia, primaryImage.className, primaryImage.sizes, product.title);
                const nextSecondary = createImageElement(modelMedia, secondaryImage?.className || primaryImage.className.replace('media--first', 'media--second'), primaryImage.sizes, product.title);
                primaryImage.replaceWith(nextPrimary);
                if (secondaryImage) secondaryImage.replaceWith(nextSecondary);
                else nextPrimary.after(nextSecondary);
              }
              return;
            }
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      if (handleProduct !== 'evangelina-cross-birthstone-pendant-necklace') secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
    if (wrapper.dataset.product === 'evangelina-cross-birthstone-tennis-bracelet' && !wrapper.dataset.braceletOptionsReady) {
      wrapper.dataset.braceletOptionsReady = 'true';
      wrapper.querySelector('.js-color-swatches input:checked')?.click();
      const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
      if (addButton) {
        addButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          const selected = wrapper.querySelector('.js-color-swatches input:checked');
          window.location.assign(selected?.dataset.variantLink || window.Shopify.routes.root + 'products/evangelina-cross-birthstone-tennis-bracelet');
        }, true);
      }
    }
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})();

// A connected element also initializes cards inserted by filters or pagination.
if (!customElements.get('suri-card-material')) {
  customElements.define('suri-card-material', class extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.suri-editorial-card');
      this.update = (event) => {
        const selected = this.card.querySelector('.js-color-swatches input:checked');
        const label = selected && this.card.querySelector(`label[for="${CSS.escape(selected.id)}"]`);
        if (label) { const text = label.title || label.textContent.trim(); const finishText = this.card.hasAttribute('data-suri-card-material') && selected.value.startsWith('10K') ? text.replace(/^10K /, '') : text; this.textContent = this.hasAttribute('data-short-finish') ? finishText.replace('18K Gold Vermeil over 925 Sterling Silver', '18K Gold Vermeil · 925 Silver').replace('18K Rose Gold Vermeil over 925 Sterling Silver', '18K Rose Gold Vermeil · 925 Silver') : (this.dataset.finishLabel ? `${this.dataset.finishLabel}: ${finishText}` : finishText); }
        if (event && selected?.dataset.variantLink) {
          const variantLink = selected.dataset.variantLink;
          this.card.querySelector('.card__title a')?.setAttribute('href', variantLink);
          this.card.querySelector('[data-product-url]')?.setAttribute('data-product-url', variantLink);
          getMaterialFilterProduct(this.card.dataset.product).then(product => {
            if (!selected.checked || !this.isConnected) return;
            const variant = product.variants.find(item => String(item.id) === selected.dataset.variantId);
            if (variant) updateCardPriceForVariant(this.card, variant);
          }).catch(() => {});
        }
      };
      this.card.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() { this.card?.removeEventListener('change', this.update); }
  });
}

// Keep the selected finish's product and model images paired, including filtered grids.
const suriCardFinishKey = (value = '') => {
  const color = value.toLowerCase();
  if (color.includes('rose')) return 'rose';
  if (color.includes('silver') || color.includes('white gold')) return 'silver';
  if (color.includes('gold')) return 'gold';
  return color;
};
const suriCardMaterialForColor = (value = '') => value.startsWith('10K') ? 'solid' : 'vermeil'; const syncSuriCardMaterial = (card) => { const selected = card.querySelector('.js-color-swatches input:checked'); if (!selected) return; const material = suriCardMaterialForColor(selected.value); card.dataset.suriCardMaterial = material; card.querySelectorAll('[data-suri-card-material-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.suriCardMaterialChoice === material))); }; document.addEventListener('click', event => { const button = event.target.closest('[data-suri-card-material-choice]'); const card = button?.closest('[data-suri-card-material]'); if (!card) return; event.preventDefault(); const selected = card.querySelector('.js-color-swatches input:checked'); const finish = suriCardFinishKey(selected?.value || 'Gold'); const target = Array.from(card.querySelectorAll('.js-color-swatches input')).find(input => suriCardMaterialForColor(input.value) === button.dataset.suriCardMaterialChoice && suriCardFinishKey(input.value) === finish); if (!target) return; card.dataset.suriCardMaterial = button.dataset.suriCardMaterialChoice; if (!target.checked) target.click(); syncSuriCardMaterial(card); }); document.addEventListener('change', event => { const card = event.target.closest('.js-color-swatches input')?.closest('[data-suri-card-material]'); if (card) syncSuriCardMaterial(card); }); const suriCardMediaMaps = new WeakMap();
const suriCardSelectionVersions = new WeakMap();
document.addEventListener('change', async (event) => {
  const input = event.target.closest('.js-color-swatches input');
  const card = input?.closest('[data-suri-finish-card]');
  if (!card || !input.checked) return;
  const version = (suriCardSelectionVersions.get(card) || 0) + 1;
  suriCardSelectionVersions.set(card, version);
  try {
    if (!suriCardMediaMaps.has(card)) {
      suriCardMediaMaps.set(card, JSON.parse(card.querySelector('[data-suri-finish-media]')?.textContent || '{}'));
    }
    const group = suriCardMediaMaps.get(card)[suriCardFinishKey(input.value)];
    if (!group) return;
    const product = await getMaterialFilterProduct(card.dataset.product);
    if (!card.isConnected || !input.checked || suriCardSelectionVersions.get(card) !== version) return;
    const mediaBox = card.querySelector('.card__inner > .media');
    const primary = mediaBox?.querySelector('.media--first');
    if (!mediaBox) return;
    const productMedia = product.media.find(media => String(media.id) === group.primary);
    const modelMedia = product.media.find(media => String(media.id) === group.hover);
    const sizes = primary?.sizes || '(min-width: 990px) 33vw, 50vw';
    // Build both replacements before altering the DOM; never retain the old finish's hover.
    const nextPrimary = productMedia ? createImageElement(productMedia, 'motion-reduce media--first', sizes, product.title) : null;
    const nextSecondary = modelMedia ? createImageElement(modelMedia, 'motion-reduce media--second', sizes, product.title) : null;
    mediaBox.querySelectorAll('.media--first, .media--second, .suri-finish-media-empty, .placeholder-svg').forEach(node => node.remove());
    if (nextPrimary) mediaBox.append(nextPrimary);
    else {
      const message = document.createElement('span');
      message.className = 'suri-finish-media-empty';
      message.textContent = 'Photos for this finish are not available yet.';
      mediaBox.append(message);
    }
    if (nextSecondary) mediaBox.append(nextSecondary);
    if (input.dataset.variantId) updateCardLinksForVariant(card, input.dataset.variantId);
    const addButton = card.querySelector('.card__add-to-cart button[name="add"]');
    if (addButton) addButton.setAttribute('aria-disabled', 'false');
  } catch (error) {
    // A failed load must not leave the previous color's model visible.
    if (suriCardSelectionVersions.get(card) === version) card.querySelector('.media--second')?.remove();
    console.warn('Unable to update product card finish imagery', error);
  }
});

document.addEventListener('change', (event) => {
  const input = event.target;
  const filterName = 'filter.v.t.shopify.color-pattern';
  if (!(input instanceof HTMLInputElement) || input.name !== filterName || !input.checked) return;
  document.querySelectorAll('input[name="' + filterName + '"]').forEach((other) => {
    if (other !== input) other.checked = other.value === input.value;
  });
}, true);

